/**
 * Хранение токенов в localStorage.
 *
 * Компромисс осознанный: API отдаёт токены в теле ответа, а не в httpOnly-куке,
 * потому что тот же контракт будет использовать мобильный клиент. Плата за это —
 * доступность токенов из JavaScript, поэтому защита от XSS (экранирование,
 * отсутствие dangerouslySetInnerHTML на пользовательских данных) обязательна.
 */

const ACCESS_KEY = 'studioapp.accessToken';
const REFRESH_KEY = 'studioapp.refreshToken';

export const tokenStorage = {
  getAccess: (): string | null => localStorage.getItem(ACCESS_KEY),

  getRefresh: (): string | null => localStorage.getItem(REFRESH_KEY),

  save(accessToken: string, refreshToken: string): void {
    localStorage.setItem(ACCESS_KEY, accessToken);
    localStorage.setItem(REFRESH_KEY, refreshToken);
  },

  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};
